import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Zap, Shield, TrendingUp, Cpu } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function CleanCopterPage() {
  return <div className="bg-white" data-id="element-194">
      {/* Hero */}
      <div className="relative bg-gray-900 text-white py-24 overflow-hidden" data-id="element-195">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1506947411487-a56738267384?auto=format&fit=crop&q=80')] bg-cover bg-center opacity-20" data-id="element-196"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-197">
          <div className="inline-block px-4 py-1.5 rounded-full bg-blue-500/20 border border-blue-400 text-blue-300 font-medium mb-6 backdrop-blur-sm" data-id="element-198">
            Innovation Made in Aachen
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-6 tracking-tight" data-id="element-199">
            CleanCopter
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-200">
            Die Zukunft der Fassadenreinigung ist da. <br data-id="element-201" />
            Patentierte Drohnentechnologie für effiziente, sichere und brillante
            Ergebnisse.
          </p>
        </div>
      </div>

      {/* Main Feature */}
      <section className="py-20" data-id="element-202">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-204">
            <div data-id="element-205">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-206">
                Revolutionäre Reinigungstechnik
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed" data-id="element-207">
                In enger Zusammenarbeit mit der{' '}
                <span className="font-bold text-blue-800" data-id="element-208">
                  Fachhochschule Aachen
                </span>{' '}
                entwickeln wir den CleanCopter stetig weiter. Diese patentierte
                Reinigungsdrohne ist in der Lage, selbstständig auch die
                schwierigsten Reinigungsaufgaben an Glasfassaden zu erledigen.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-209">
                Damit spielen wir ganz vorn in der ersten Liga und sind für die
                Zukunft gewappnet. Der CleanCopter erreicht Stellen, die für
                konventionelle Reinigungsmethoden schwer zugänglich oder
                gefährlich sind.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-210">
                <a href="https://www.CleanCopter.com" target="_blank" rel="noopener noreferrer" data-id="element-211">
                  <Button variant="primary" data-id="element-212">
                    Zur CleanCopter Website
                    <ArrowRight className="ml-2 w-4 h-4" data-id="element-213" />
                  </Button>
                </a>
                <Link to="/kontakt" data-id="element-214">
                  <Button variant="outline" data-id="element-215">Beratung anfordern</Button>
                </Link>
              </div>
            </div>
            <div className="bg-gray-100 rounded-2xl p-8 border border-gray-200" data-id="element-216">
              <div className="aspect-video bg-gray-200 rounded-lg flex items-center justify-center mb-4" data-id="element-217">
                <span className="text-gray-400 font-medium" data-id="element-218">
                  Video / Bild Platzhalter CleanCopter
                </span>
              </div>
              <p className="text-sm text-gray-500 text-center italic" data-id="element-219">
                Der CleanCopter im Einsatz an einer Glasfassade
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-20 bg-blue-50" data-id="element-220">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
          <div className="text-center mb-16" data-id="element-222">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-223">
              Vorteile der Drohnenreinigung
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-224">
              Warum der Einsatz des CleanCopters für Ihre Immobilie die richtige
              Entscheidung ist.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-225">
            {[{
            icon: <Shield className="w-8 h-8 text-emerald-500" data-id="element-226" />,
            title: 'Sicherheit',
            desc: 'Kein Personaleinsatz in gefährlichen Höhen notwendig. Minimierung von Arbeitsunfallrisiken.'
          }, {
            icon: <TrendingUp className="w-8 h-8 text-emerald-500" data-id="element-227" />,
            title: 'Effizienz',
            desc: 'Schnellere Reinigung großer Flächen ohne zeitaufwendigen Gerüstbau oder Hubsteiger.'
          }, {
            icon: <Zap className="w-8 h-8 text-emerald-500" data-id="element-228" />,
            title: 'Erreichbarkeit',
            desc: 'Reinigung von schwer zugänglichen Stellen, Überhängen und komplexen Architekturen.'
          }, {
            icon: <Cpu className="w-8 h-8 text-emerald-500" data-id="element-229" />,
            title: 'Innovation',
            desc: 'Modernste Sensorik sorgt für präzisen Abstand und schonende Reinigung der Oberflächen.'
          }].map((item, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-blue-100 hover:shadow-md transition-shadow" data-id="element-230">
                <div className="mb-4" data-id="element-231">{item.icon}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-232">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm" data-id="element-233">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>
    </div>;
}